
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import Team from "../../teamComponents/team";
 import teamimage from '../../../images/footerLinksImages/enterpreneur/team.jpg';
function JoinOurTeam() {

    const keywords = [
        { title: "Career Opportunities", summary: "Explore exciting career opportunities with us and take your professional journey to new heights." },
        { title: "Work Culture", summary: "Join a dynamic, inclusive, and innovative team environment that fosters growth and creativity." },
        { title: "Employee Benefits", summary: "Enjoy competitive salaries, comprehensive benefits, and a healthy work-life balance." },
        { title: "Professional Development", summary: "We provide ample opportunities for career advancement and skills development through training and workshops." },
        { title: "Collaborative Environment", summary: "Work with talented individuals across various departments to achieve common goals and drive success." },
        { title: "Innovation and Creativity", summary: "Be a part of a company that values innovation and encourages creative thinking to solve challenges." },
        { title: "Leadership and Mentorship", summary: "Gain guidance from experienced leaders and mentors who support your personal and professional growth." },
        { title: "Employee Recognition", summary: "We recognize and celebrate the achievements and contributions of our employees in meaningful ways." },
        { title: "Flexible Work Options", summary: "Take advantage of flexible work hours and remote work opportunities to suit your lifestyle." },
        { title: "Diversity and Inclusion", summary: "Join a team that values diversity and fosters an inclusive culture where everyone is respected." }
      ];
    return (<>
        <Header />
        
        <BannerFooter
            title="Join Our Team"
            text="Are you passionate about trading, the stock market, or web technologies? Join our dynamic team and become part of a growing organization that thrives on innovation and expertise. We’re looking for skilled professionals in market analysis, web development, and financial technologies who are eager to contribute to cutting-edge solutions. Whether you’re an experienced trader, a developer specializing in financial systems, or someone with a strong background in stock market strategies, we offer a collaborative work environment where your skills will grow. Help us redefine the future of financial technology and web development!"
            imageone={teamimage}
            imagetwo={teamimage}
        />
        <Team/>
        <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Join Our Team</h2>
    <div className="accordion" id="joinTeamAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#joinTeamAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default JoinOurTeam